import { ILayout } from '../../types/layout';

export const LAYOUT_DEFAULT: ILayout = {
  deviceType: 'phone',
};
